<template>
  <div class="app">
    <Header />
    <div class="page">
      <div id="map-container"></div>
      <MapDetails />
    </div>
    <Info />
  </div>
</template>

<script>
// import ControlBar from "./components/ControlBar/ControlBar.vue";
// import MainMenu from "./components/Menu/MainMenu.vue";
// import FreeFlightMobileControls from "./components/Controls/FreeFlightMobileControls.vue";
// import ZoomButtons from "./components/Controls/ZoomButtons.vue";
import { events } from "./events";
import Header from "./elements/Header/Header.vue";
import MapDetails from "./components/Details/MapDetails.vue";
import Info from "./components/Info/Info.vue";

export default {
  name: "App",
  components: {
    // FreeFlightMobileControls,
    // MainMenu,
    // ControlBar,
    // ZoomButtons,
    Header,
    MapDetails,
    Info,
  },
  computed: {
    showMapMenu() {
      return (
        this.mapViewer.mapState === "loading" ||
        this.mapViewer.mapState === "loaded"
      );
    },
  },
  data() {
    return {
      loading: true,
      appState: null,
      mapViewer: null,
    };
  },
  mounted() {
    events.on("map_loaded", this.onLoad);
  },
  methods: {
    onLoad({ bluemap }) {
      this.appState = bluemap.appState;
      this.mapViewer = bluemap.mapViewer.data;

      console.log(bluemap);

      this.loading = false;
    },
  },
};
</script>

<style lang="scss">
@import "./scss/global.scss";

#map-container {
  width: 100%;
  height: 780px;

  div {
    canvas {
      border-style: solid;
      border-color: #18181a;
      border-width: 2px;

      border-radius: 15px;

      box-sizing: border-box;
    }
  }
}

.page {
  max-width: 1601px;

  display: flex;

  margin-left: auto;
  margin-right: auto;
}

.app {
  position: absolute;
  width: 100%;

  background-color: #0a0a0a;

  z-index: 10000; // put over bluemap markers

  // pointer-events: none;

  font-size: 1rem;
  @media (max-width: $mobile-break) {
    font-size: 1.5rem;
  }

  .map-state-message {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: var(--theme-fg-light);
    line-height: 1em;
    text-align: center;
  }
}
</style>

<!-- <div v-if="loading">Loading...</div>
  <div v-else id="app" class="app">
    <FreeFlightMobileControls
      v-if="
        mapViewer.mapState === 'loaded' && appState.controls.state === 'free'
      "
    />
    <ZoomButtons
      v-if="
        showMapMenu &&
        appState.controls.showZoomButtons &&
        appState.controls.state !== 'free'
      "
    />
    <ControlBar />
    <div v-if="mapViewer.mapState !== 'loaded'" class="map-state-message">
      {{ $t("map." + mapViewer.mapState) }}
    </div>
    <MainMenu :menu="appState.menu" />
  </div> -->
